import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ShellComponent } from './shared/shell/shell.component';

const PUBLIC_ROUTES = ['/direct-purchasing', '/thsc-purchasing'];

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        ShellComponent
    ]
})
export class AppComponent {
  title = 'CareerScopeAdmin';

  constructor(private router: Router) {}

  isPublicRoute(): boolean {
    return PUBLIC_ROUTES.some(route => this.router.url.startsWith(route));
  }
}
